<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <div class="page-section">
    <h2>L'Assurance Prévoyance : Protéger Ceux Que Vous Aimez</h2>
    <p>
      L'<strong>assurance prévoyance</strong> est conçue pour maintenir votre niveau de vie et celui de vos proches 
      en cas d'accident de la vie : maladie grave, invalidité, perte d'autonomie ou décès. Elle complète les prestations 
      de la Sécurité Sociale qui ne couvrent qu'une partie des besoins financiers.
    </p>
  </div>

  <div class="page-section">
    <h3>Pourquoi Souscrire une Assurance Prévoyance ?</h3>
    <ul>
      <li><strong>Protection financière</strong> : maintien du niveau de vie en cas d'incapacité de travail</li>
      <li><strong>Soutien à la famille</strong> : capital ou rente versés aux bénéficiaires en cas de décès</li>
      <li><strong>Couverture invalidité</strong> : indemnités en cas d'invalidité permanente</li>
      <li><strong>Dépendance</strong> : prise en charge en cas de perte d'autonomie</li>
      <li><strong>Frais d'obsèques</strong> : capital pour couvrir les frais funéraires</li>
    </ul>
  </div>

  <div class="page-section highlight-box">
    <h3>Les Garanties Prévoyance</h3>
    <div class="guarantees-grid">
      <div class="guarantee-card">
        <i class="pi pi-shield"></i>
        <h4>Incapacité de Travail</h4>
        <p>Indemnités journalières en cas d'arrêt de travail</p>
        <ul>
          <li>Complément de salaire</li>
          <li>Maintien du niveau de vie</li>
          <li>Versement dès le 1er jour</li>
        </ul>
      </div>

      <div class="guarantee-card">
        <i class="pi pi-user"></i>
        <h4>Invalidité Permanente</h4>
        <p>Rente en cas d'invalidité totale ou partielle</p>
        <ul>
          <li>Rente mensuelle</li>
          <li>Capital unique possible</li>
          <li>Adaptation du logement</li>
          <li>Assistance à domicile</li>
        </ul>
      </div>

      <div class="guarantee-card">
        <i class="pi pi-heart"></i>
        <h4>Décès</h4>
        <p>Capital versé aux bénéficiaires</p>
        <ul>
          <li>Capital décès</li>
          <li>Rente conjoint</li>
          <li>Rente éducation enfants</li>
          <li>Frais d'obsèques</li>
        </ul>
      </div>

      <div class="guarantee-card">
        <i class="pi pi-users"></i>
        <h4>Dépendance</h4>
        <p>Prise en charge perte d'autonomie</p>
        <ul>
          <li>Rente mensuelle à vie</li>
          <li>Capital aménagement</li>
          <li>Services d'assistance</li>
          <li>Aide aux aidants</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="page-section">
    <h3>Qui est Concerné ?</h3>
    <p>
      L'assurance prévoyance s'adresse à tous, mais certaines situations nécessitent une attention particulière :
    </p>
    <ul>
      <li><strong>Famille avec enfants</strong> : protéger l'avenir des enfants en cas de décès d'un parent</li>
      <li><strong>Couple mono-revenu</strong> : sécuriser le revenu familial</li>
      <li><strong>Travailleurs indépendants</strong> : compléter une protection sociale limitée</li>
      <li><strong>Emprunteurs</strong> : garantir le remboursement du prêt immobilier</li>
      <li><strong>Seniors</strong> : anticiper la perte d'autonomie</li>
    </ul>
  </div>

  <div class="page-section info-box">
    <h3><i class="pi pi-info-circle"></i> Bon à Savoir</h3>
    <p>
      <span class="highlight">La Sécurité Sociale</span> ne verse qu'environ 50% du salaire en cas d'arrêt de travail, 
      et ce pendant une durée limitée. En cas d'invalidité, la pension versée représente seulement 30 à 50% du salaire.
    </p>
    <p>
      L'assurance prévoyance permet de combler cet écart et de maintenir votre niveau de vie ainsi que celui de votre famille.
    </p>
  </div>

  <div class="page-section">
    <h3>Comment Choisir Votre Assurance Prévoyance ?</h3>
    <p>Le choix dépend de votre situation personnelle et professionnelle :</p>
    <div class="features-grid">
      <div class="feature-item">
        <i class="pi pi-briefcase"></i>
        <h4>Votre Statut Professionnel</h4>
        <p>Salarié, indépendant, fonctionnaire : les besoins diffèrent selon votre protection sociale de base</p>
      </div>
      <div class="feature-item">
        <i class="pi pi-home"></i>
        <h4>Votre Situation Familiale</h4>
        <p>Célibataire, en couple, avec enfants : adaptez les garanties à votre famille</p>
      </div>
      <div class="feature-item">
        <i class="pi pi-chart-line"></i>
        <h4>Vos Revenus</h4>
        <p>Déterminez le capital ou la rente nécessaire pour maintenir votre niveau de vie</p>
      </div>
      <div class="feature-item">
        <i class="pi pi-calendar"></i>
        <h4>Votre Âge</h4>
        <p>Plus vous souscrivez tôt, plus les cotisations sont avantageuses</p>
      </div>
    </div>
  </div>

  <div class="page-section">
    <h3>Les Avantages de Passer par Brokins</h3>
    <ul>
      <li><strong>Analyse de vos besoins</strong> : évaluation personnalisée de votre situation</li>
      <li><strong>Comparaison des offres</strong> : accès aux meilleures garanties du marché</li>
      <li><strong>Optimisation fiscale</strong> : conseils sur la déductibilité des cotisations</li>
      <li><strong>Accompagnement sinistre</strong> : assistance lors de la déclaration et du suivi</li>
      <li><strong>Révision annuelle</strong> : adaptation des garanties à l'évolution de votre situation</li>
    </ul>
  </div>

  <div class="page-section cta-box">
    <h3>Protégez Votre Famille Dès Aujourd'hui</h3>
    <p>
      Obtenez un devis personnalisé et découvrez les solutions de prévoyance adaptées à votre situation.
    </p>
    <button class="btn-cta" (click)="navigateToComparison()">
      Comparer les assurances prévoyance
    </button>
  </div>

</app-page-layout>
